import type { FC } from "react";
import { defaultColor } from "../constants";
import type { IconProps } from "./types";

export const Automation: FC<IconProps> = ({
  color = defaultColor,
  height = 24,
}) => (
  <svg
    width="25"
    height={height}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_1634_6586"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="25"
      height="24"
    >
      <rect x="0.5" width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1634_6586)">
      <path
        d="M19.0999 20.4016C18.4166 20.4016 17.8166 20.2016 17.2999 19.8016C16.7832 19.4016 16.4332 18.9016 16.2499 18.3016H10.3999C9.48324 18.3016 8.70407 17.9807 8.0624 17.3391C7.42074 16.6974 7.0999 15.9182 7.0999 15.0016C7.0999 14.0849 7.42074 13.3057 8.0624 12.6641C8.70407 12.0224 9.48324 11.7016 10.3999 11.7016H13.3999C13.9774 11.7016 14.4718 11.4953 14.883 11.0829C15.2943 10.6704 15.4999 10.1746 15.4999 9.59536C15.4999 9.01616 15.2943 8.5224 14.883 8.11406C14.4718 7.70573 13.9774 7.50156 13.3999 7.50156H8.7499C8.56657 8.10156 8.21657 8.60156 7.6999 9.00156C7.18324 9.40156 6.58324 9.60156 5.8999 9.60156C5.06657 9.60156 4.35824 9.3099 3.7749 8.72656C3.19157 8.14323 2.8999 7.4349 2.8999 6.60156C2.8999 5.76823 3.19157 5.0599 3.7749 4.47656C4.35824 3.89323 5.06657 3.60156 5.8999 3.60156C6.58324 3.60156 7.18324 3.80156 7.6999 4.20156C8.21657 4.60156 8.56657 5.10156 8.7499 5.70156H13.3999C14.4832 5.70156 15.4041 6.08073 16.1624 6.83906C16.9207 7.5974 17.2999 8.51823 17.2999 9.60156C17.2999 10.6849 16.9207 11.6057 16.1624 12.3641C15.4041 13.1224 14.4832 13.5016 13.3999 13.5016H10.3999C9.9874 13.5016 9.63428 13.6489 9.34053 13.9435C9.04678 14.2381 8.8999 14.5923 8.8999 15.006C8.8999 15.4197 9.04678 15.7724 9.34053 16.0641C9.63428 16.3557 9.9874 16.5016 10.3999 16.5016H16.2499C16.4332 15.9016 16.7832 15.4016 17.2999 15.0016C17.8166 14.6016 18.4166 14.4016 19.0999 14.4016C19.9332 14.4016 20.6416 14.6932 21.2249 15.2766C21.8082 15.8599 22.0999 16.5682 22.0999 17.4016C22.0999 18.2349 21.8082 18.9432 21.2249 19.5266C20.6416 20.1099 19.9332 20.4016 19.0999 20.4016ZM5.8999 7.80156C6.2399 7.80156 6.5249 7.68656 6.7549 7.45656C6.9849 7.22656 7.0999 6.94156 7.0999 6.60156C7.0999 6.26156 6.9849 5.97656 6.7549 5.74656C6.5249 5.51656 6.2399 5.40156 5.8999 5.40156C5.5599 5.40156 5.2749 5.51656 5.0449 5.74656C4.8149 5.97656 4.6999 6.26156 4.6999 6.60156C4.6999 6.94156 4.8149 7.22656 5.0449 7.45656C5.2749 7.68656 5.5599 7.80156 5.8999 7.80156Z"
        fill={color}
      />
    </g>
  </svg>
);
